import { createContext as A, useContext as v } from "react";
import { a as o } from "./vanilla-CSAfDK5R.js";
const h = () => {
  const r = o(""), s = o(!1), e = o(0), c = o(!1), a = o(!1), n = o(!1), i = o(
    (t) => t(n),
    (t, l, d, p) => {
      if (typeof window > "u" || t(a))
        return;
      const f = t(n), u = t(e) || 0, C = Math.round(
        d + (f ? u : 0)
      );
      l(n, p > C), l(s, !0);
    }
  ), m = o(
    (t) => t(a) || t(i)
  );
  return {
    idAtom: r,
    hasComputedAtom: s,
    navigationMinimalWidthAtom: e,
    isMobileMenuOpenAtom: c,
    isBreakpointCollapsedAtom: a,
    isOverflowCollapsedAtom: i,
    isCollapsedAtom: m
  };
}, w = A(
  h()
), N = () => v(w);
export {
  w as N,
  h as c,
  N as u
};
//# sourceMappingURL=NavigationState-EOPjgMu1.js.map
